import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import { TransactionsState } from "../states/transactions/transactions.state";

@Injectable()
export class DupTransactionsService {
    /**
     *
     */
    constructor(private store: Store) {
        
    }

    isDup(drugId: number, locationID?: number): boolean {
        const dupTransactions = this.store.selectSnapshot(TransactionsState.duplicateTransactions) || [];
        return dupTransactions.some(x => (!locationID || x.inventoryLocationID === locationID) && x.drugId === drugId);
      }
}